import { JobDetailsModal, type Props } from './JobDetailsModal';

export { JobDetailsModal, /** @deprecated */ JobDetailsModal as JobInfoModal };
export type { Props as JobDetailsModalProps, /** @deprecated */ Props as JobInfoModalProps };
export default JobDetailsModal;
